import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingFeature {
}
ApiEpBillingFeature.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/feature/`,
    method: "GET",
});
ApiEpBillingFeature.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/feature/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=feature.js.map